import { useOrder } from "../../hooks/orders"
import { useParams } from "react-router-dom"
import {
  Container,
  Center,
  Flex,
  Heading,
  Text,
  Spinner,
} from "@chakra-ui/react"
import { CheckCircleIcon } from "@chakra-ui/icons"

const SuccessPage = () => {
  let { orderId } = useParams()
  const { order, isLoading, locations } = useOrder(orderId)

  return (
    <main>
      <Container maxW="container.xl" bg="white" padding="4">
        <Heading align="center">Agrifood Loghino Vittoria</Heading>
      </Container>

      <Container maxW="container.xl" padding="4" mb={16}>
        {isLoading ? (
          <Center>
            <Spinner />
          </Center>
        ) : (
          <Flex direction="column" justify="center" align="center">
            <CheckCircleIcon w={24} h={24} color="green.500" />
            <Heading as="h3" size="lg" marginTop={8}>
              Ordine {order.orderId} Confermato
            </Heading>
            <Text align="center">
              Riceverai a breve una email di conferma con un riepilogo del tuo
              ordine
            </Text>
            <Text align="center" mt={4}>
              Il tuo ordine verrà consegnato indicativamente:
            </Text>
            <Text align="center" as="strong">
              {locations.find((location) => location.id === order.city)
                .isRitiro && order.address === ""
                ? locations.find((location) => location.id === order.city)
                    .pickupDescription
                : locations.find((location) => location.id === order.city)
                    .description}
            </Text>
          </Flex>
        )}
      </Container>
    </main>
  )
}

export default SuccessPage
